import {createReducer} from '../../utils/reducerHelper';
import * as types from '../../constants/authConstants';

const initialState = {
  isAuthenticated: false,
  isAuthenticating: false,
  statusText: null,
  loginData: null,
  token: null,
  user: null,
};

export default createReducer(initialState, {
  [types.LOGIN_RESET]: (state, action) => {
    return Object.assign(initialState, action);
  },
  [types.LOGIN_USER_REQUEST]: (state) => {
    return Object.assign({}, state, {
      isAuthenticating: true,
      statusText: null
    });
  },
  [types.LOGIN_REQUEST_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      statusText: '',
      loginAttempts: 0,
      loginRequestToken: payload.loginRequestToken,
      firstName: payload.firstName,
      phoneLast4digits: payload.phoneLast4Digits,
    });
  },
  [types.LOGIN_CHECKUP]: (state, payload) => { // todo: what is this?
    return Object.assign({}, state, {
      isAuthenticating: false,
      isAuthenticated: true,
      statusText: '',
      loginAttempts: 0,
      loginData: payload.loginData,
      token: payload.token,
      user: payload.user,
    });
  },
  [types.LOGIN_REQUEST_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticating: false,
      isAuthenticated: false,
      statusText: payload.statusText,
      loginData: null,
      token: null,
      user: null,
    });
  },
  [types.LOGIN_OTP_TYPE_RESET]: (state) => {
    return Object.assign({}, state, {
      isLoadingOtpType: false,
      isOtpTypeSuccess: false,
      isOtpTypeFail: false,
      otpType: undefined,
      statusText: null
    });
  },
  [types.OTP_TYPE_LOGIN_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isLoadingOtpType: true,
      isOtpTypeSuccess: false,
      isOtpTypeFail: false,
      loginOtpTypeError: undefined,
      otpType: payload.otpType,
      statusText: null
    });
  },
  [types.OTP_TYPE_LOGIN_REQUEST_SUCCESS]: (state) => {
    return Object.assign({}, state, {
      isLoadingOtpType: false,
      isOtpTypeSuccess: true,
      isOtpTypeFail: false,
      loginOtpTypeError: undefined,
      statusText: null
    });
  },
  [types.OTP_TYPE_LOGIN_REQUEST_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isLoadingOtpType: false,
      isOtpTypeSuccess: false,
      isOtpTypeFail: true,
      loginOtpTypeError: payload.error,
      statusText: null
    });
  },
  [types.VERIFY_OTP_LOGIN_REQUEST]: (state  ) => {
    return Object.assign({}, state, {
      isLoadingOtp: true,
      isOtpSuccess: false,
      isOtpFail: false,
      loginOtpVerifyError: undefined,
      statusText: null
    });
  },
  [types.VERIFY_OTP_LOGIN_REQUEST_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticating: false,
      isAuthenticated: true,
      isLoadingOtp: false,
      isOtpSuccess: true,
      isOtpFail: false,
      loginOtpVerifyError: undefined,
      loginData: payload.loginData,
      token: payload.token,
      user: payload.user,
      statusText: null
    });
  },
  [types.VERIFY_OTP_LOGIN_REQUEST_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isLoadingOtp: false,
      isOtpSuccess: false,
      isOtpFail: true,
      loginOtpVerifyError: payload.error,
      statusText: null
    });
  },
  [types.LOGIN_OTP_FOCUS_AFTER_FAIL]: (state) => {
    return Object.assign({}, state, {
      isLoadingOtp: false,
      isOtpSuccess: false,
      isOtpFail: false,
      statusText: null
    });
  },
  [types.LOGOUT_USER]: (state) => {
    return Object.assign({}, state, {
      isAuthenticated: false,
      statusText: 'You have been successfully logged out.',
      loginData: null,
      token: null,
      user: null,
    });
  },
  [types.UPDATE_STATUS_TEXT]: (state, payload) => {
    return Object.assign({}, state, {
      statusText: payload
    });
  },
  [types.REDIRECT_TO_RESET_PASSWORD]: (state) => {
    return Object.assign({}, state, {
      isAuthenticating: false
    });
  },
  [types.EMAIL_REGISTRATION_TOKEN_VALIDATED]: (state, payload) => {
    return Object.assign({}, state, {
      user: payload.user,
    });
  },
});



// WEBPACK FOOTER //
// ./src/reducers/withOtp/authReducer2.js